import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import constant from "../../constant";
import SuccessMessage from "../common/SuccessMessage";
import ErrorMessage from "../common/ErrorMessage";
import { collegeDropDown } from "../../actions/campusDriveAction";
import { cityList, getCityList, getStateLists } from "../../actions/utilitiesAction";

const CampusDriveForm = (props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { detail } = props;

    const [error, setError] = useState(false);
    const [collegeOptions, setCollegeOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);



    useEffect(() => {
        collegeDropDown().then((res) => {
            if (res.status) {
                setCollegeOptions(res.result)
            }
        })

        getStateLists(102).then(res => {
            if (res.status) {
                setStateOptions(res.result.list)
            }
        })
    }, [])



    const [drive, setDrive] = useState({
        DRIVE_NAME: "",
        DRIVE_CODE: "",
        DRIVE_DESCRIPTION: "",

        COLLEGE_ID: "",
        COLLEGE_NAME: "",
        COLLEGE_CITY: "",
        COLLEGE_STATE: "",

        DRIVE_DATE: "",
        DRIVE_START_TIME: "",
        DRIVE_END_TIME: "",

        MAX_EMPLOYERS: "",
        MAX_STUDENTS: "",
        REGISTRATION_DEADLINE: "",

        DRIVE_STATUS: "DRAFT"
    });

    useEffect(() => {

        cityList(drive.COLLEGE_STATE).then(res => {
            if (res.status) {
                setCityOptions(res.result.list)
            }
        })
    }, [drive.COLLEGE_STATE])

    const onChange = (e) => {
        const { name, value } = e.target;
        setDrive({ ...drive, [name]: value });
    };

    const onChangeCollege = (e) => {
        const collegeId = e.target.value;

        const selectedCollege = collegeOptions.find(
            (item) => item.COLLEGE_ID == collegeId
        );

        if (selectedCollege) {
            setDrive({
                ...drive,
                COLLEGE_ID: collegeId,
                COLLEGE_NAME: selectedCollege.COLLEGE_NAME,
                COLLEGE_CITY: selectedCollege.CITY,
                COLLEGE_STATE: selectedCollege.STATE
            });
        }
    };


    const onSubmit = (e) => {
        e.preventDefault();

        if (
            drive.DRIVE_NAME.trim().length === 0 ||
            drive.COLLEGE_NAME.trim().length === 0 ||
            drive.DRIVE_DATE.length === 0 ||
            drive.DRIVE_START_TIME.length === 0 ||
            drive.DRIVE_END_TIME.length === 0
        ) {
            setError(true);
            return;
        }

        const model = { ...drive };
        if (detail) model.ID = detail.ID;

        props.onSubmit(model);
        setError(false);
    };

    useEffect(() => {
        document.title = id
            ? constant.title.EditCampusDrive
            : constant.title.AddCampusDrive;
    }, []);

    useEffect(() => {
        if (detail) {
            setDrive({
                DRIVE_NAME: detail.DRIVE_NAME,
                DRIVE_CODE: detail.DRIVE_CODE,
                DRIVE_DESCRIPTION: detail.DRIVE_DESCRIPTION,

                COLLEGE_ID: detail.COLLEGE_ID,
                COLLEGE_NAME: detail.COLLEGE_NAME,
                COLLEGE_CITY: detail.COLLEGE_CITY,
                COLLEGE_STATE: detail.COLLEGE_STATE,

                DRIVE_DATE: detail.DRIVE_DATE,
                DRIVE_START_TIME: detail.DRIVE_START_TIME,
                DRIVE_END_TIME: detail.DRIVE_END_TIME,

                MAX_EMPLOYERS: detail.MAX_EMPLOYERS,
                MAX_STUDENTS: detail.MAX_STUDENTS,
                REGISTRATION_DEADLINE: detail.REGISTRATION_DEADLINE,

                DRIVE_STATUS: detail.DRIVE_STATUS
            });
        }
    }, [detail]);

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">

                    {/* Header */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 style={{ fontSize: "18px" }}>
                                    {id ? "Edit Campus Drive" : "Create Campus Drive"}
                                </h4>
                            </div>
                        </div>
                    </div>

                    {/* Form */}
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title mb-4">Campus Drive Details</h4>

                            {props.showMsg &&
                                (props.response.status ? (
                                    <SuccessMessage message={props.response.messageCode} />
                                ) : (
                                    <ErrorMessage message={props.response.error} />
                                ))}

                            <form>

                                {/* Drive Info */}
                                <div className="row">
                                    <div className="col-lg-6 mb-3">
                                        <label>Drive Name *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DRIVE_NAME"
                                            value={drive.DRIVE_NAME}
                                            onChange={onChange}
                                        />
                                        {error && !drive.DRIVE_NAME && (
                                            <span className="text-danger">Required</span>
                                        )}
                                    </div>

                                    <div className="col-lg-6 mb-3">
                                        <label>Drive Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DRIVE_CODE"
                                            value={drive.DRIVE_CODE}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>

                                {/* College Info */}
                                <div className="row">
                                    <div className="col-lg-6 mb-3">
                                        <label>College Name *</label>
                                        <select
                                            type="text"
                                            className="form-select"
                                            name="COLLEGE_ID"
                                            value={drive.COLLEGE_ID}
                                            onChange={onChangeCollege}
                                        >
                                            <option value={''}>Select College</option>
                                            {collegeOptions.map(item => {
                                                return (<option value={item.COLLEGE_ID}>{item.COLLEGE_NAME} ({item.COLLEGE_CODE})</option>)
                                            })}
                                        </select>
                                        {error && !drive.COLLEGE_ID && (
                                            <span className="text-danger">Required</span>
                                        )}
                                    </div>

                                    <div className="col-lg-3 mb-3">
                                        <label>City</label>
                                        <select
                                            type="text"
                                            className="form-select"
                                            name="COLLEGE_CITY"
                                            value={drive.COLLEGE_CITY}
                                            onChange={onChange}
                                        >
                                            <option value={''}> Select City</option>
                                            {cityOptions.map((item) => {
                                                return (
                                                    <option value={item.CITY_ID}>{item.CITY}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-lg-3 mb-3">
                                        <label>State</label>
                                        <select
                                            className="form-select"
                                            name="COLLEGE_STATE"
                                            value={drive.COLLEGE_STATE}
                                            onChange={onChange}
                                        >
                                            <option value={''}> Select State</option>
                                            {stateOptions.map((item) => (
                                                <option key={item.STATE_ID} value={item.STATE_ID}>
                                                    {item.STATE}
                                                </option>
                                            ))}

                                        </select>
                                    </div>
                                </div>

                                {/* Schedule */}
                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <label>Date *</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="DRIVE_DATE"
                                            value={drive.DRIVE_DATE}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="col-lg-4 mb-3">
                                        <label>Start Time *</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            name="DRIVE_START_TIME"
                                            value={drive.DRIVE_START_TIME}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="col-lg-4 mb-3">
                                        <label>End Time *</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            name="DRIVE_END_TIME"
                                            value={drive.DRIVE_END_TIME}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>

                                {/* Capacity */}
                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <label>Max Employers</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="MAX_EMPLOYERS"
                                            value={drive.MAX_EMPLOYERS}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="col-lg-4 mb-3">
                                        <label>Max Students</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="MAX_STUDENTS"
                                            value={drive.MAX_STUDENTS}
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="col-lg-4 mb-3">
                                        <label>Registration Deadline</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            name="REGISTRATION_DEADLINE"
                                            value={drive.REGISTRATION_DEADLINE}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>

                                {/* Description */}
                                <div className="mb-3">
                                    <label>Description</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="DRIVE_DESCRIPTION"
                                        value={drive.DRIVE_DESCRIPTION}
                                        onChange={onChange}
                                    />
                                </div>

                                {/* Actions */}
                                <div className="text-end">
                                    <button
                                        type="button"
                                        onClick={onSubmit}
                                        className="btn btn-success"
                                    >
                                        {id ? "Update Drive" : "Create Drive"}
                                    </button>
                                    &nbsp;
                                    <button
                                        type="button"
                                        onClick={() => navigate(constant.component.campusDriveList.url)}
                                        className="btn btn-danger"
                                    >
                                        Cancel
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampusDriveForm;
